import Card from "@mui/material/Card";
import React from 'react';

/**
 * OutlinedCustomCard Component
 */
export const OutlinedCustomCard = (props) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderWidth: '2px',
        borderColor: '#acacac',
        borderRadius: '10px',
        margin: "5px 5px",
        height: '100%',
        // 2024.5.8 MyMine Version1.5対応 Add Start
        ...props.sx
        // 2024.5.8 MyMine Version1.5対応 Add End
      }}>
      {props.children}
    </Card>);
};